import request from 'superagent';
import {cache} from 'locache';
import toggleBodyScroll from './toggleBodyScroll';
import {closeNewsletterOverlay} from './newsletterSignup';

let clientLoginForm = document.getElementsByClassName('client-area-form__overlay');

export const initClientAreaForm = () => {

  if (clientLoginForm.length === 0) {
    return;
  }
  clientLoginForm = clientLoginForm[0];

  const formCloseButton = clientLoginForm.getElementsByClassName('modal__overlay__close-button')[0];

  formCloseButton.addEventListener('click', () => {
    //closeLoginForm();
  });

  const clientAreaLink = document.getElementsByClassName('header__client-area-link');
  if (clientAreaLink.length > 0) {
    clientAreaLink[0].addEventListener('click', () => {
      //displayLoginForm();
    });
  }
};
